<template>
	<c-dialog ref="dialog" mask-close mode="slide" width="800"  enable-flex>
		<!-- 信息头部 -->
		<div class="info-header">
			<h3>维修单位：{{deliveryData.repair_unit || '-'}}</h3>
			<p>{{getProductText(deliveryData)}}<span v-if="deliveryData.produce_imei"> | IMEI：{{deliveryData.produce_imei}}</span></p>
		</div>

		<!-- 表单 -->
		<c-form ref="form" vertical unit-width="100%">
			<c-form-item label="产品背贴码" required>
				<div class="scan-input-wrap flex-center-cross">
					<c-input
						ref="codeInput"
						v-model="formData.produce_unique_code"
						placeholder="请扫描/输入背贴码"
                        :disabled="disabled"
						@keyup.enter.native="scanProduct"
					></c-input>
				</div>
			</c-form-item>

			<c-form-item label="维修项目（可多选）" required>
				<c-select
					v-model="formData.repair_items"
					:options="repairItemOptions"
					multiple
					filterable
					placeholder="请选择"
					@change="onRepairItemChange"
				></c-select>
			</c-form-item>

			<!-- 动态维修金额输入 -->
			<c-form-item
				v-for="item in selectedRepairItems"
				:key="item.value"
				:label="'（' + item.name + '）维修金额'"
				required
			>
				<div class="amount-input-wrap flex-center-cross">
					<c-input
						v-model="formData.amounts[item.value]"
						type="number"
                        decimal="2"
						:range="[-99999999, 99999999]"
						placeholder="请输入维修金额"
						append-text="元"
					></c-input>
				</div>
			</c-form-item>

			<c-form-item label="备注">
				<c-input type="textarea" v-model="formData.remark" placeholder="请输入" maxlength="200"></c-input>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button size="dialog" color="main" @click="submitHandle">确定</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
export default {
	name: 'repairCompleteDialog',

	data() {
		return {
			deliveryData: {},
			formData: {
				produce_unique_code: '',
				produce_unique_code_id: '',
				repair_items: [],
				amounts: {},
				remark: ''
			},
            disabled: false,
			repairItemOptions: []
		}
	},

	computed: {
		/*********已选维修项列表**********/
		selectedRepairItems() {
			if (!this.repairItemOptions || !this.formData.repair_items.length) return [];
			var dicMap = {};
			this.repairItemOptions.forEach(function(item) {
				dicMap[item.value] = item;
			});
			return this.formData.repair_items.map(val => {
				var item = dicMap[val];
				return item ? {name: item.name, value: val} : null;
			}).filter(Boolean);
		}
	},

	methods: {
		/*********获取产品信息文字**********/
		getProductText(data) {
			var parts = [];
			if (data.brand_name) parts.push(data.brand_name);
			if (data.model_name) parts.push(data.model_name);
			if (data.color_name) parts.push(data.color_name);
			if (data.memory_name) parts.push(data.memory_name);
			return parts.join(' ') || '-';
		},

		/*********打开弹框**********/
		open(data) {
			this.deliveryData = data || {};
            this.loadRepairItemOptions();
			this.formData = {
				produce_unique_code: data && data.produce_unique_code || '',
				produce_unique_code_id: '',
				repair_items: [],
				amounts: {},
				remark: ''
			};
            this.disabled = !!(data && data.produce_unique_code)

            if(this.deliveryData.produce_unique_code){
                this.scanProduct();
            }
			this.$refs.dialog.open({title: '送修完成'});
		},

		/*********加载维修项选项**********/
		loadRepairItemOptions() {
			this.request({
				url: '/system/dic/options',
				data: {dic_type_code: 'REPAIR_ITEM'},
				success: (data) => {
					this.repairItemOptions = (data || []).map(item => ({
						name: item.name,
						value: item.value
					}));
				}
			});
		},

		/*********扫码查询产品**********/
		scanProduct() {
			var code = this.formData.produce_unique_code.trim();
			if (!code) {
				this.$message({message: '请输入背贴码', type: 'warn'});
				return;
			}
			this.request({
				url: '/repair/product/queryByCode',
				data: {produce_unique_code: code},
				loading: true,
				success: (data) => {
					// 非送修状态的条码：没有进行中的送修记录
					if (!data.delivery_id) {
						this.$message({message: '该商品当前不是【送修中】状态，无法操作', type: 'warn'});
						this.formData.produce_unique_code = '';
						this.formData.produce_unique_code_id = '';
						return;
					}
					this.formData.produce_unique_code_id = data.produce_unique_code_id;
					this.deliveryData.produce_imei = data.produce_imei || '';
					// 扫码模式下回填送修记录ID和维修单位
					if (!this.deliveryData.id) {
						this.$set(this.deliveryData, 'id', data.delivery_id);
						this.$set(this.deliveryData, 'repair_unit', data.repair_unit || '');
						this.$set(this.deliveryData, 'brand_name', data.brand_name || '');
						this.$set(this.deliveryData, 'model_name', data.model_name || '');
						this.$set(this.deliveryData, 'color_name', data.color_name || '');
						this.$set(this.deliveryData, 'memory_name', data.memory_name || '');
					}
				},
				fail: (msg) => {
					this.$message({message: msg, type: 'warn'});
					this.formData.produce_unique_code = '';
					this.formData.produce_unique_code_id = '';
				}
			});
		},

		/*********维修项变化时初始化金额**********/
		onRepairItemChange(val) {
			if (val && Array.isArray(val)) {
				val.forEach(itemVal => {
					if (this.formData.amounts[itemVal] === undefined) {
						this.$set(this.formData.amounts, itemVal, '');
					}
				});
			}
		},

		/*********提交**********/
		submitHandle() {
			if (!this.formData.produce_unique_code_id) {
				this.$message({message: '请先扫描或输入产品背贴码', type: 'warn'});
				return;
			}
			if (!this.deliveryData.id) {
				this.$message({message: '该产品没有进行中的送修记录', type: 'warn'});
				return;
			}
			if (!this.formData.repair_items.length) {
				this.$message({message: '请选择维修项目', type: 'warn'});
				return;
			}

			// 校验每个维修项的金额
			for (var i = 0; i < this.formData.repair_items.length; i++) {
				var itemVal = this.formData.repair_items[i];
				var amount = this.formData.amounts[itemVal];
				var itemName = itemVal;
				for (var j = 0; j < this.repairItemOptions.length; j++) {
					if (this.repairItemOptions[j].value === itemVal) {
						itemName = this.repairItemOptions[j].name;
						break;
					}
				}
				if (amount === '' || amount === undefined || amount === null) {
					this.$message({message: '请输入（' + itemName + '）的维修金额', type: 'warn'});
					return;
				}
				var amountNum = parseFloat(amount);
				if (isNaN(amountNum) || amountNum === 0) {
					this.$message({message: '（' + itemName + '）的维修金额不能为0', type: 'warn'});
					return;
				}
			}

			this.$confirm({
				message: '确认完成送修吗？',
				cancelButton: true,
				resolve: () => {
					this.submitComplete();
				}
			});
		},

		/*********执行提交**********/
		submitComplete() {
			var items = this.formData.repair_items.map(function(itemVal) {
				return {repair_item: itemVal, repair_amount: this.formData.amounts[itemVal]};
			}.bind(this));

			this.request({
				url: '/repair/delivery/complete',
				data: {
					id: this.deliveryData.id,
					produce_unique_code: this.formData.produce_unique_code,
					produce_unique_code_id: this.formData.produce_unique_code_id,
					items: JSON.stringify(items),
					remark: this.formData.remark
				},
				loading: true,
				success: () => {
					this.$message({message: '送修完成', type: 'success'});
					this.$emit('resolve');
					this.$refs.dialog.close();
				},
				fail: (msg) => {
					this.$message({message: msg, type: 'error'});
				}
			});
		},

		/*********关闭弹框**********/
		closeDialog() {
			this.$refs.dialog.close();
		}
	}
}
</script>

<style lang="stylus" scoped>
.info-header
	text-align center
	padding 0 0 12px
	background-color #F0F3FF
	h3
		font-size 18px
		font-weight 600
		color #3D5EFF
		line-height 46px
	p
		margin 0
		font-size 13px
		color #999

.scan-input-wrap
	gap 8px
	>>> .c-input
		flex-grow 1

.amount-input-wrap
	gap 8px
	>>> .c-input
		flex-grow 1
	.amount-unit
		flex-shrink 0
		font-size 14px
		color #666
</style>
